import { Card, CardActions, CardContent } from '@material-ui/core';
import {
  getClassroomInfoById,
  getContractTypesById,
  getJobsById,
  getStudentInvitation,
  getTeamInfoById,
  getTrainingById,
  responseInvitationAffiliation,
} from '@webapps/business';
import {
  Button,
  Modal,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useAuth } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

const AcceptInvitation = () => {
  const { params } = useRouter();
  const { css } = useStyles();
  const { apiToken } = useAuth();

  const { id: idInvitation } = params;

  if (!apiToken) {
    return (
      <Redirect
        to={{ pathname: ROUTES_PATH.SIGN_UP, search: `invite=${idInvitation}` }}
      />
    );
  }

  const { data: invitation = {} } = useQuery(getStudentInvitation, {
    key: ['invitation', idInvitation],
    variables: { id: idInvitation },
  });

  const reload = () => {
    window.location.reload();
  };

  return (
    <>
      <InfoClasseOrTeam
        contractType={invitation?.contractType}
        id={invitation?.groupId}
        idInvite={invitation?.id}
        job={invitation?.job}
        status={invitation?.status}
        type={invitation?.type}
      />
    </>
  );
};

const InfoClasseOrTeam = ({
  contractType,
  id,
  idInvite,
  job,
  status,
  type,
}) => {
  const {
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles();
  const { addToast } = useToast();
  const { push } = useRouter();

  const { data: classroom = {} } = useQuery(getClassroomInfoById, {
    key: ['classroom', id],
    variables: { id },
    enabled: type === 'join_classroom',
  });

  const { data: team = {} } = useQuery(getTeamInfoById, {
    key: ['team', id],
    variables: { id },
    enabled: type === 'join_team',
  });

  const {
    error: errorAction,
    isLoading: isLoadingAction,
    isSuccess: isSuccessAction,
    mutate: mutateSetAffiliateAction,
  } = useMutation(responseInvitationAffiliation);

  const responseInvit = async (action) => {
    await mutateSetAffiliateAction({
      id: idInvite,
      action,
    });
  };

  const [invitation, setInvitation] = useState("");

  useEffect(() => {
    if (errorAction) {
      addToast({
        status: 'error',
        message: "Problème pour accepter l'invitation",
      });
    }
    if (isSuccessAction) {
      invitation === "ACCEPTED" ?
        addToast({
          status: 'success',
          message: 'Invitation acceptée',
        })
        : 
        addToast({
          status: 'error',
          message: 'Invitation rejeté',
        })
      push(ROUTES_PATH.STUDENT_DASHBOARD);
    }
  }, [isSuccessAction, errorAction]);

  return (
    <Card className={css({ margin: spacing(5) })} variant="outlined">
      <CardContent>
        {type === 'join_team' ? (
          <div className={global.subTitle}>
            Une entreprise vous a invité a rejoindre une équipe
          </div>
        ) : (
          <div className={global.subTitle}>
            Un établissement de formation vous a invité a rejoindre une classe
          </div>
        )}
        <div style={{marginTop: spacing(2)}} className={global.infoText}>
          L'invitation concerne:
        </div>
        <div>
          {type === 'join_team' ? (
            <ul>
              <li>{team?.business?.name}</li>
              <Job id={job} />
              <ContractType id={contractType} />
            </ul>
          ) : (
            <ul>
              <li>{classroom?.school?.name}</li>
              <Training id={classroom?.training} />
            </ul>
          )}
        </div>
      </CardContent>
      <CardActions>
        {status === 'pending' && (
          <>
            <Button
              color="primary"
              disabled={isLoadingAction}
              onClick={() => {responseInvit('reject'); setInvitation("REJECTED")}}
              variant="outlined"
            >
              Décliner
            </Button>
            <Button
              className={css({ background: '#47C509' })}
              color="primary"
              disabled={isLoadingAction}
              onClick={() => {responseInvit('accept'); setInvitation("ACCEPTED")}}
              variant="contained"
            >
              Accepter
            </Button>
          </>
        )}
        {status === 'ACCEPTED' && (
          <p
            className={css({
              color: 'green',
              fontSize: '13.500px',
              fontWeight: 'bold',
            })}
          >
            Invitation acceptée
          </p>
        )}
        {status === 'REJECTED' && (
          <p
            className={css({
              color: 'red',
              fontSize: '13.500px',
              fontWeight: 'bold',
            })}
          >
            Invitation rejetée
          </p>
        )}
      </CardActions>
    </Card>
  );
};

InfoClasseOrTeam.propTypes = {
  id: PropTypes.string,
  idInvite: PropTypes.string,
  type: PropTypes.string,
  contractType: PropTypes.string,
  job: PropTypes.string,
  status: PropTypes.string,
};

const Training = ({ id }) => {
  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', id],
    variables: { id },
  });

  return (
    <>
      <li>{training?.label}</li>
      <li>{training?.degree?.level?.label}</li>
    </>
  );
};

Training.propTypes = {
  id: PropTypes.string,
};

const Job = ({ id }) => {
  const { data: job = {} } = useQuery(getJobsById, {
    key: ['job', id],
    variables: { id },
  });

  return <li>{job?.label}</li>;
};

Job.propTypes = {
  id: PropTypes.string,
};

const ContractType = ({ id }) => {
  const { data: contractType = {} } = useQuery(getContractTypesById, {
    key: ['contractType', id],
    variables: { id },
  });

  return <li>{contractType?.label}</li>;
};

ContractType.propTypes = {
  id: PropTypes.string,
};

export default AcceptInvitation;